import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinmumbai() {



    const cardData = {

keyword: "Best Cab Service in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Best Cab Service in Mumbai for outstation travel, weekend trips, family vacations, pilgrimage journeys, corporate travel, and long-distance rides. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop across Mumbai, and safe highway driving, we ensure a smooth, comfortable, and hassle-free outstation travel experience across India.",

topPlaces: [
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra’s most popular hill stations known for strawberry farms, viewpoints, lakes, and cool climate. It is a top weekend getaway destination from Mumbai for families and couples."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s most famous beach destination known for nightlife, water sports, beaches, and Portuguese heritage. It is a top long-distance holiday destination from Mumbai."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are scenic hill stations near Mumbai known for waterfalls, valleys, caves, and monsoon beauty. They are ideal for short weekend road trips."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba and attracts millions of devotees every year. It is one of the most booked spiritual cab routes from Mumbai."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is famous for vineyards, temples, and Trimbakeshwar Jyotirlinga. It is a popular mix of spiritual and leisure travel destination from Mumbai."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts. It is perfect for short weekend trips and relaxation."
    },
    {
        title: "Pune",
        description:
            "Pune is a major IT, education, and cultural hub known for its pleasant weather and modern lifestyle. It is a frequently traveled outstation route from Mumbai."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a historical city famous for Ajanta and Ellora Caves. It is a UNESCO heritage destination ideal for cultural and historical tours."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, rich culture, and traditional cuisine. It is a popular pilgrimage and family travel destination from Mumbai."
    },
    {
        title: "Matheran",
        description:
            "Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and peaceful nature surroundings near Mumbai."
    }
],



services: [
{
name: "Best Cab Service in Mumbai",
description: "Mumbai Airport Cab offers Best Cab Service in Mumbai for safe, reliable, and comfortable transportation across the city and outstation destinations. Whether you need airport transfers, local travel, corporate commuting, family trips, sightseeing tours, or long-distance journeys, we provide a wide range of well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, Mini Bus, and luxury cars. Our professional chauffeurs ensure punctual pickup, smooth driving, and safe travel experience. With transparent pricing, 24x7 availability, doorstep service, and easy booking options, we deliver a high-quality and stress-free travel experience in Mumbai."
},
{
name: "Mumbai Best Cab Service",
description: "Mumbai Best Cab Service by Mumbai Airport Cab is designed to provide premium travel comfort with reliability and affordability. Our service includes clean vehicles, experienced drivers, flexible booking options, and excellent customer support. Suitable for airport transfers, business travel, family outings, weddings, and outstation trips, we ensure a smooth and comfortable journey for every passenger."
},
{
name: "Top Cab Service Mumbai",
description: "Top Cab Service Mumbai offers high-standard transportation solutions for local and intercity travel. Mumbai Airport Cab provides well-maintained vehicles, professional chauffeurs, and flexible travel plans for all types of passengers. Whether it is daily commuting or long-distance travel, we ensure safety, comfort, and punctual service."
},
{
name: "Reliable Cab Service Mumbai",
description: "Reliable Cab Service Mumbai ensures dependable transportation with on-time pickup, verified drivers, and clean vehicles. Mumbai Airport Cab focuses on safety, customer satisfaction, and smooth travel experience for airport transfers, city rides, and outstation journeys across India."
},
{
name: "Affordable Cab Service Mumbai",
description: "Affordable Cab Service Mumbai offers budget-friendly travel solutions without compromising comfort and safety. Mumbai Airport Cab provides transparent pricing, economical packages, and professional drivers for local and outstation travel needs."
},
{
name: "24x7 Cab Service Mumbai",
description: "24x7 Cab Service Mumbai provides round-the-clock transportation availability for emergency travel, airport transfers, late-night rides, and early morning trips. Mumbai Airport Cab ensures quick response, safe vehicles, and reliable drivers at any time of the day or night."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai Taxi Service by Mumbai Airport Cab offers convenient transportation for local commuting, business travel, sightseeing, and airport transfers. We provide clean cars, professional chauffeurs, and flexible booking options for a smooth travel experience."
},
{
name: "Mumbai Car Hire Service",
description: "Mumbai Car Hire Service provides flexible rental options for local and outstation travel. Mumbai Airport Cab offers a wide fleet of vehicles with experienced drivers for business trips, family travel, tourism, and corporate transportation."
},
{
name: "Mumbai Outstation Cab Service",
description: "Mumbai Outstation Cab Service offers reliable long-distance travel to destinations like Pune, Nashik, Goa, Shirdi, Lonavala, Mahabaleshwar, and more. Mumbai Airport Cab ensures comfortable vehicles, safe highway driving, and professional chauffeurs for stress-free journeys."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai Airport Cab Service provides timely pickup and drop services for domestic and international terminals. We offer flight tracking, luggage assistance, and 24x7 availability to ensure smooth and hassle-free airport transfers."
},
{
name: "Mumbai Local Cab Service",
description: "Mumbai Local Cab Service offers convenient city transportation for daily commuting, office travel, shopping trips, hospital visits, and short-distance travel. Mumbai Airport Cab ensures affordable pricing and reliable service across Mumbai."
},
{
name: "Premium Cab Service Mumbai",
description: "Premium Cab Service Mumbai provides luxury travel experience with high-end vehicles, professional chauffeurs, and superior comfort. Ideal for VIP travel, corporate executives, weddings, and special occasions."
},
{
name: "Mumbai Online Cab Booking",
description: "Mumbai Online Cab Booking allows customers to book rides instantly with easy and user-friendly booking options. Mumbai Airport Cab ensures quick confirmation, transparent pricing, and multiple vehicle choices."
},
{
name: "Instant Cab Booking Mumbai",
description: "Instant Cab Booking Mumbai provides fast ride availability for urgent travel needs. Mumbai Airport Cab ensures immediate dispatch of nearby vehicles for quick pickup and smooth transportation."
},
{
name: "Mumbai Ride Service",
description: "Mumbai Ride Service offers quick and reliable transportation for short-distance and on-demand travel across the city. We ensure safe, affordable, and comfortable rides anytime in Mumbai."
},
{
name: "Mumbai Family Cab Service",
description: "Mumbai Family Cab Service provides safe and spacious travel options for families. Mumbai Airport Cab offers comfortable vehicles, experienced drivers, and flexible booking for family trips and vacations."
},
{
name: "Mumbai Corporate Cab Service",
description: "Mumbai Corporate Cab Service is designed for business professionals requiring reliable transportation for meetings, office travel, and client visits. We ensure punctual and professional travel experience."
},
{
name: "Mumbai Tour Cab Service",
description: "Mumbai Tour Cab Service offers sightseeing and travel packages covering popular attractions, beaches, and heritage locations. Mumbai Airport Cab ensures comfortable guided travel for tourists."
},
{
name: "Mumbai Budget Cab Service",
description: "Mumbai Budget Cab Service provides economical travel options for daily commuting and short trips. Mumbai Airport Cab ensures affordable pricing with safe and reliable transportation."
},
{
name: "Mumbai Luxury Cab Service",
description: "Mumbai Luxury Cab Service offers premium vehicles with high-end comfort for VIP travel, weddings, corporate events, and special occasions. Mumbai Airport Cab ensures top-class service and professional chauffeurs."
}
],

tableData: [
["Best Cab Service in Mumbai","Mumbai Best Cab Service"],
["Top Cab Service Mumbai","Reliable Cab Service Mumbai"],
["Affordable Cab Service Mumbai","24x7 Cab Service Mumbai"],
["Mumbai Taxi Service","Mumbai Car Hire Service"],
["Mumbai Outstation Cab Service","Mumbai Airport Cab Service"],
["Mumbai Local Cab Service","Premium Cab Service Mumbai"],
["Mumbai Online Cab Booking","Instant Cab Booking Mumbai"],
["Mumbai Ride Service","Mumbai Family Cab Service"],
["Mumbai Corporate Cab Service","Mumbai Tour Cab Service"],
["Mumbai Budget Cab Service","Mumbai Luxury Cab Service"]
],









whychoose: [
    {
        WhyChooseheading: "Best Cab Service in Mumbai for Every Journey",
        WhyChoosedescription: "Mumbai Airport Cabs offers reliable transportation solutions for airport transfers, local travel, outstation journeys, corporate transportation, sightseeing tours, and family trips across Mumbai."
    },
    {
        WhyChooseheading: "24x7 Cab Booking Availability",
        WhyChoosedescription: "Our cab services are available round the clock, making travel convenient for early morning flights, late-night arrivals, business meetings, and emergency transportation needs."
    },
    {
        WhyChooseheading: "Extensive Fleet of Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "Local, Airport, and Outstation Expertise",
        WhyChoosedescription: "Whether you need transportation within Mumbai or travel to Pune, Nashik, Shirdi, Goa, Ahmedabad, Hyderabad, Bangalore, and other destinations, we provide dependable travel solutions."
    },
    {
        WhyChooseheading: "Professional and Experienced Chauffeurs",
        WhyChoosedescription: "Our trained drivers ensure safe driving, route expertise, punctual service, and a smooth travel experience throughout every journey."
    },
    {
        WhyChooseheading: "Convenient Pickup Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and surrounding areas."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can book one-way transfers, round trips, multi-day tours, business travel packages, and customized itineraries according to their needs."
    },
    {
        WhyChooseheading: "Trusted by Families and Corporate Clients",
        WhyChoosedescription: "From individual travelers and tourists to corporate executives and large groups, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why is Mumbai Airport Cabs considered one of the best cab services in Mumbai?",
        answer: "Mumbai Airport Cabs provides reliable vehicles, professional drivers, airport transfers, outstation travel, local transportation, and customer-focused service."
    },
    {
        question: "Can I book a cab for Mumbai Airport transfers?",
        answer: "Yes, airport pickup and drop services are available for domestic and international travelers at Mumbai Airport."
    },
    {
        question: "Which vehicles are available for booking?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Do you provide outstation cab services from Mumbai?",
        answer: "Yes, outstation cab services are available for Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Ahmedabad, Hyderabad, Bangalore, Jaipur, and many other destinations."
    },
    {
        question: "Can corporate companies book regular cab services?",
        answer: "Yes, we provide transportation solutions for executives, employees, business meetings, airport transfers, and corporate events."
    },
    {
        question: "Do you provide Tempo Travellers and Mini Buses?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family tours, weddings, educational trips, and group transportation."
    },
    {
        question: "Can I schedule a cab in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "Do you offer Mumbai Darshan and sightseeing cabs?",
        answer: "Yes, customers can book cabs for Mumbai sightseeing, shopping trips, tourist attractions, and customized travel itineraries."
    },
    {
        question: "Are your drivers verified and experienced?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local as well as interstate travel routes."
    },
    {
        question: "How can I book the best cab service in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohan Khanna",
        feedback:
            "For both airport transfers and business meetings, Mumbai Airport Cabs has consistently provided excellent service. The vehicles are clean, the drivers are professional, and every trip is comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Kavita Deshpande",
        feedback:
            "Our family has used Mumbai Airport Cabs multiple times for local and outstation travel. The booking process is simple, the vehicles are well-maintained, and the overall service is outstanding.",
        rating: 5
    }
];







































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Best Cab Service in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/best-cab-service-in-mumbai.jpg",
"description": "Book the best cab service in Mumbai for local travel, airport transfers, outstation trips, corporate rides, and family travel. Mumbai Airport Cabs offers 24x7 reliable taxi service with professional drivers, clean vehicles, affordable pricing, and instant online booking.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/best-cab-service-in-mumbai"
}
};





    return (
        <div>




<Helmet>
  <title>Best Cab Service in Mumbai | 24x7 Taxi & Car Hire | +91 9545731161</title>

<meta
 name="description"
 content="Book the best cab service in Mumbai for local, airport, outstation, corporate, and family travel. 24x7 reliable taxi service with affordable fares, professional drivers, and instant booking."
/>

<meta
 name="keywords"
 content="best cab service in mumbai, mumbai best cab service, top cab service mumbai, reliable cab service mumbai, affordable cab service mumbai, 24x7 cab service mumbai, mumbai taxi service, mumbai car hire service, mumbai outstation cab service, mumbai airport cab service, mumbai local cab service, premium cab service mumbai, mumbai online cab booking, instant cab booking mumbai, mumbai ride service, mumbai family cab service, mumbai corporate cab service, mumbai tour cab service, mumbai budget cab service, mumbai luxury cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabserviceinmumbai;